export default __webpack_public_path__ + "static/media/slider-smc360-2.158070b2.jpg";